// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-main{background:#f0f1f5;overflow:auto;width:100%}.v-main__wrapper{position:relative}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
